export const DEFAULT_ROUNDED_TO_NUMBER = 9000;

type Props = {
    roundedTo?: number;
    totalFound: number;
};

export const getRoundedNumberText = ({ roundedTo = DEFAULT_ROUNDED_TO_NUMBER, totalFound }: Props) => {
    const formatter = new Intl.NumberFormat('en-US');
    if (totalFound >= roundedTo) {
        return `${formatter.format(roundedTo)}+`;
    }
    return formatter.format(totalFound);
};
